import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { FCMService } from 'src/app/services/notifications/fcm.service';
import { RealtimeService } from 'src/app/services/realtime/realtime.service';
import { AICoreStateModule } from 'src/app/store/aicore/aicore.state.module';
import { LoadActiveIncidentCount } from 'src/app/store/incident-activity/incident-activity.actions';
import { StatuspagesStateModule } from 'src/app/store/statuspages/statuspages.state.module';
import { LoadSubscriptionAction } from 'src/app/store/subscription/subscription.actions';
import { LoadUserAction } from 'src/app/store/user/user.actions';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { TopbarComponent } from '../../layout/topbar/topbar.component';

@Component({
  selector: 'app-layout-dashboard',
  templateUrl: './internal.component.html',
  imports: [
    SidebarComponent,
    TopbarComponent,
    RouterOutlet,
    StatuspagesStateModule,
    AICoreStateModule,
  ],
})
export class InternalLayoutComponent implements OnInit {
  rt = inject(RealtimeService);
  fcm = inject(FCMService);

  private store = inject(Store);

  ngOnInit(): void {
    this.store.dispatch(new LoadUserAction());
    this.store.dispatch(new LoadSubscriptionAction());
    this.store.dispatch(new LoadActiveIncidentCount());
  }
}
